<template>
  <div class="app">
    <div class="title">
      <div class="dis">
        <div class="title_text">项目管理</div>
      </div>
    </div>

    <div class="head_box">
      <div class="ipt_list">
        <div class="box1">
          <div class="dis">
            <div class="first_title">项目名称</div>
            <el-input v-model="value1" placeholder="请输入内容" clearable></el-input>
          </div>
          <div class="dis">
            <div class="first_title">合同编号</div>
            <el-input v-model="value2" placeholder="请输入内容" clearable></el-input>
          </div>
        </div>
        <div class="box1">
          <div class="dis">
            <div class="other_title">客户名称</div>
            <el-select v-model="selectedCustomerId" placeholder="请选择" filterable clearable @change="onCustomerChange">
              <el-option v-for="item in customerList" :key="item.id" :label="item.customerName" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="dis">
            <div class="other_title">项目状态</div>
            <el-select v-model="value3" placeholder="请选择" filterable clearable>
              <el-option label="保修中" value="1"></el-option>
              <el-option label="已过期" value="2"></el-option>
            </el-select>
          </div>
        </div>
        <div class="box1">
          <div class="dis">
            <div class="other_title">负责人</div>
            <el-select v-model="value4" placeholder="请选择" filterable clearable>
              <el-option v-for="item in PersonList" :key="item.personName" :label="item.personName"
                :value="item.personName">
              </el-option>
            </el-select>
          </div>
          <div class="dis">
            <el-button class="search_btn dis_center" type="primary" @click="rold()">
              <div class="dis_center">
                <div>搜索</div>
              </div>
            </el-button>

            <el-button class="Add_btn dis_center" type="primary" @click="add_btn(0)">
              <div class="dis_center">
                <img class="img11" src="../../assets/12.png" alt="" />
                <div>新增</div>
              </div>
            </el-button>
          </div>

        </div>
      </div>
    </div>
    <div class="table_pad">
      <div class="table">
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" stripe
          @selection-change="handleSelectionChange" :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ textAlign: 'center' }">
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column type="index" label="序号" width="65">
          </el-table-column>
          <el-table-column prop="contractNumber" label="合同编号" min-width="10%">
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" min-width="10%">
          </el-table-column>
          <el-table-column prop="customerName" label="客户名称" min-width="10%">
          </el-table-column>
          <el-table-column prop="contractAmount" label="合同金额" min-width="8%">
          </el-table-column>
          <el-table-column prop="projectStatus" label="项目状态" min-width="8%">
            <template slot-scope="scope">
              <div class="dis_center ing" v-if="scope.row.projectStatus == '1'">
                保修中
              </div>
              <div class="dis_center over" v-else-if="scope.row.projectStatus == '2'">
                已过期
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="responsiblePerson" label="负责人" min-width="8%">
          </el-table-column>
          <el-table-column prop="expirationTime" label="到期时间" min-width="10%">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="10%">
          </el-table-column>
          <el-table-column prop="address" label="操作" min-width="15%">
            <template slot-scope="scope">
              <div class="dis_center table_btn">
                <div class="dis" @click="jump(scope.row)">
                  <div>资料管理</div>
                </div>
                <div class="dis" @click="add_btn(1, scope.row)">
                  <div>修改</div>
                </div>
                <div class="dis" @click="setCopyqrCode(scope.row.id)">
                  <div>二维码</div>
                </div>
                <div class="dis table_delete" @click="delete_btn(0, scope.row.id)">
                  <div>删除</div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page_box">
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
          :current-page.sync="pageNumber" :total="total">
        </el-pagination>
      </div>
    </div>

    <div class="shardow dis_center" v-if="show_shardow">
      <div class="show_box">
        <div class="show_title dis_center">
          <div v-if="show_type == 0">新增项目</div>
          <div v-else>修改项目</div>
          <img src="../../assets/19.png" class="img19" alt="" @click="close" />
        </div>
        <div class="show_detail" style="height: 460rem;">
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>项目名称：</div>
            <el-input class="shardow_ipt" v-model="info.projectName" placeholder="请输入"></el-input>
          </div>
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>合同编号：</div>
            <el-input class="shardow_ipt" v-model="info.contractNumber" placeholder="请输入"></el-input>
          </div>
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>所属客户：</div>
            <el-select v-model="info.customerId" placeholder="请选择" @change="onCustomerChange">
              <el-option v-for="item in customerList" :key="item.id" :label="item.customerName" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>合同金额：</div>
            <el-input class="shardow_ipt" v-model="info.contractAmount" placeholder="请输入"></el-input>
          </div>
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>到期时间：</div>
            <el-date-picker v-model="info.expirationTime" type="datetime" placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </div>
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title"><span style="color: red;">* </span>负责人：</div>
            <el-select v-model="info.responsiblePerson" placeholder="请选择" @change="onCustomerChange2">
              <el-option v-for="item in PersonList" :key="item.personName" :label="item.personName"
                :value="item.personName">
              </el-option>
            </el-select>
          </div>
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title">备 注：</div>
            <el-input class="shardow_ipt" v-model="info.remarks" placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="shardow_btn dis_center">
          <div class="shardow_btn1 dis_center" @click="close">取消</div>
          <button class="shardow_btn2 dis_center" @click="save" :disabled="disabled_save">
            确定
          </button>
        </div>
      </div>
    </div>

    <div class="shardow dis_center" v-if="show_delete">
      <div class="show_box">
        <div class="show_title dis_between">
          <div>删除确认</div>
          <img src="../../assets/19.png" class="img19" alt="" @click="close" />
        </div>
        <div class="dis_center shardow_deleteInfo">
          <img src="../../assets/20.png" class="img20" alt="" />
          <div>确定要删除所选择的项目吗？</div>
        </div>
        <div class="shardow_btn dis_center">
          <div class="shardow_btn1 dis_center" @click="close">取消</div>
          <div class="shardow_btn2 dis_center" @click="remove">确定</div>
        </div>
      </div>
    </div>

    <div class="shardow dis_center" v-if="show_shardow2">
      <div class="show_box">
        <div class="show_title dis_center">
          <div v-if="show_type == 0">项目二维码</div>
          <div v-else>项目二维码</div>
          <img src="../../assets/19.png" class="img19" alt="" @click="close" />
        </div>
        <div class="show_detail2 dis_center">
          <div id="qrcode"></div>
          <div class="url_text">{{ show_url }}</div>
        </div>
        <div class="shardow_btn dis_center">
          <div class="shardow_btn1 dis_center" @click="close">取消</div>
          <button class="shardow_btn2 dis_center" @click="downs" :disabled="disabled_save">
            保存图片
          </button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import QRCode from "qrcodejs2"; // 引入qrcode
import {
  img_url,
  getProjectContractMePage,
  editProjectContract,
  removeProjectContract,
  getCustomerList, getProjectPersonList
} from "../js/api";

export default {
  data() {
    return {
      img_url: "",
      max_level: 1,
      disabled_save: false,
      userInfo: {},
      info: {
        addId: "",
        addName: "",
        attachmentUrl: "",
        contractAmount: "",
        contractNumber: "",
        createTime: "",
        customerId: "",
        customerName: "",
        editId: "",
        editName: "",
        expirationTime: "",
        projectName: "",
        projectStatus: "",
        qrCodeImage: "",
        remarks: "",
        responsiblePerson: "",
      },
      multipleSelection: [],
      chooseId: "",
      show_type: 0,
      show_shardow: false,
      show_shardow2: false,
      show_delete: false,
      delete_type: 0,
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      input: "",
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      tableData: [],
      customerList: [],
      PersonList: [],
      selectedCustomerId: "",
      multipleSelection: [],
    };
  },
  components: {},

  created() {
    let that = this;
    that.img_url = img_url;
    if (that.$route.query.customerId) {
      that.selectedCustomerId = Number(that.$route.query.customerId)
    }
    that.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    that.getCustomerList();
    that.getProjectPersonList()
    that.ajaxload();
  },
  methods: {

    jump(e) {
      let that = this;
      that.$router.push('./ProjectInformation?id=' + e.id)
    },

    setCopyqrCode(e) {
      let that = this;
      that.chooseId = e;
      that.show_shardow2 = true;
      //本地调试
      let url = "https://xcx.jiechengk.cn" + "?invitationId=" + e;
      //线上正式
      // let url = this.GLOBAL.link_url + "/?liveId=" + e;
      that.show_url = url;
      this.$nextTick(function () {
        //生成二维码
        this.qrcode(url);
      });
    },
    qrcode(e) {
      let that = this;
      let qrcode = new QRCode("qrcode", {
        width: 200,
        height: 200, // 高度
        text: e, // 二维码内容
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      });
    },
    downs() {
      let that = this;
      // //找到canvas标签
      let myCanvas = document
        .getElementById("qrcode")
        .getElementsByTagName("canvas");
      let img = document.getElementById("qrcode").getElementsByTagName("img");
      // // //创建一个a标签节点
      let a = document.createElement("a");
      // //设置a标签的href属性（将canvas变成png图片）
      let imgURL = myCanvas[0].toDataURL("image/jpg");
      let ua = navigator.userAgent;
      if (ua.indexOf("Trident") != -1 && ua.indexOf("Windows") != -1) {
        // IE内核 并且  windows系统 情况下 才执行;
        var bstr = atob(imgURL.split(",")[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        var blob = new Blob([u8arr]);
        window.navigator.msSaveOrOpenBlob(blob, that.chooseId + "." + "png");
      } else if (ua.indexOf("Firefox") > -1) {
        //火狐兼容下载
        let blob = this.base64ToBlob(imgURL); //new Blob([content]);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
        a.download = " "; //下载图片名称，如果填内容识别不到，下载为未知文件，所以我这里就不填为空
        a.href = URL.createObjectURL(blob);
        a.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        ); //兼容火狐
      } else {
        //谷歌兼容下载
        img.src = myCanvas[0].toDataURL("image/jpg");
        // a.href = myCanvas[0].toDataURL('image/png').replace('image/png', 'image/octet-stream')
        a.href = img.src;
        //设置下载文件的名字
        a.download = that.chooseId;
        //点击
        a.click();
      }
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(";base64,");
      let contentType = parts[0].split(":")[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;
      let uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },
    // 获取客户列表
    getCustomerList() {
      let that = this;
      getCustomerList({}).then((res) => {
        if (res.code == 200) {
          let data = res.data;
          for (let i in data) {
            data[i].id = Number(data[i].id)
          }
          that.customerList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取人员列表
    getProjectPersonList() {
      let that = this;
      getProjectPersonList({}).then((res) => {
        if (res.code == 200) {
          let data = res.data;
          for (let i in data) {
            data[i].id = Number(data[i].id)
          }
          that.PersonList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 搜索区域客户变化
    onCustomerChange(customerId) {
      let that = this;
      // 客户变化时的处理逻辑
      for (let i in that.customerList) {
        if (that.customerList[i].id == customerId) {
          that.info.customerName = that.customerList[i].customerName
        }
      }
    },
    // 搜索区域负责人变化
    onCustomerChange2(customerId) {
      let that = this;
      // 客户变化时的处理逻辑
      // for (let i in that.PersonList) {
      //   if (that.PersonList[i].id == customerId) {
      //     that.info.personName = that.PersonList[i].personName
      //   }
      // }
    },
    // 弹窗客户变化
    onModalCustomerChange(customerId) {
      let that = this;
      let obj = that.customerList.find(item => item.id == customerId)
      that.info.customerName = obj.customerName;
    },
    rold() {
      let that = this;
      that.pageNumber = 1;
      that.ajaxload();
    },
    ajaxload() {
      let that = this;
      let json = {
        entityParam: {

        },
        pageReq: {
          pageNumber: that.pageNumber,
          pageSize: that.pageSize,
        }
      };

      if (that.value1 || that.value2 || that.value4) {
        json.keyWords = {}
      }
      if (that.value1) {
        json.keyWords.projectName = that.value1
      }
      if (that.value2) {
        json.keyWords.contractNumber = that.value2
      }
      if (that.value4) {
        json.keyWords.responsiblePerson = that.value4
      }
      if (that.selectedCustomerId) {
        json.entityParam.customerId = that.selectedCustomerId;
      }
      if (that.value3) {
        json.entityParam.projectStatus = that.value3
      }
      getProjectContractMePage(json).then((res) => {
        //console.log(res);
        if (res.code == 200) {
          let data = res.data.records;
          that.tableData = data;
          that.total = Number(data.total || 0);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    save() {
      let that = this;
      that.disabled_save = true;

      // 表单验证
      if (!that.info.projectName) {
        this.$message.error("请输入项目名称");
        that.disabled_save = false;
        return;
      }
      if (!that.info.contractNumber) {
        this.$message.error("请输入合同编号");
        that.disabled_save = false;
        return;
      }
      if (!that.info.customerId) {
        this.$message.error("请选择客户");
        that.disabled_save = false;
        return;
      }
      if (!that.info.contractAmount) {
        this.$message.error("请输入合同金额");
        that.disabled_save = false;
        return;
      }
      if (!that.info.expirationTime) {
        this.$message.error("请选择到期时间");
        that.disabled_save = false;
        return;
      }
      if (!that.info.responsiblePerson) {
        this.$message.error("请输入负责人");
        that.disabled_save = false;
        return;
      }

      let json = that.info;

      // 根据过期时间设置项目状态
      const currentTime = new Date();
      const expirationTime = new Date(that.info.expirationTime);

      if (expirationTime > currentTime) {
        json.projectStatus = "1"; // 进行中
      } else {
        json.projectStatus = "2"; // 已完成
      }

      editProjectContract(json).then((res) => {
        that.disabled_save = false;
        // console.log(res);
        if (res.code == 200) {
          that.close();
          this.$message({
            message: "保存成功",
            type: "success",
          });
          that.ajaxload();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    remove() {
      let that = this;
      let json = {
        id: that.chooseId,
      };
      removeProjectContract({ params: json }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          that.show_delete = false;
          that.ajaxload();
          this.$message.success("删除成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    delete_btn(e, w) {
      let that = this;
      if (e == 0) {
        that.chooseId = w;
      } else if (e == 1) {
        if (that.multipleSelection.length == 0) {
          this.$message({
            message: "请选择用户",
            type: "warning",
          });
          return;
        }
      }
      that.delete_type = e;
      that.show_delete = true;
    },
    add_btn(e, w) {
      let that = this;
      if (e == 0) {
        that.info = {
          addId: "",
          addName: "",
          attachmentUrl: "",
          contractAmount: "",
          contractNumber: "",
          createTime: "",
          customerId: "",
          customerName: "",
          editId: "",
          editName: "",
          expirationTime: "",
          projectName: "",
          projectStatus: "",
          qrCodeImage: "",
          remarks: "",
          responsiblePerson: "",
        };
      } else {
        that.info = JSON.parse(JSON.stringify(w));

        // 如果有学校ID，获取对应的年级列表
        if (that.info.schoolId) {
          that.getGradeListBySchool(that.info.schoolId);

          // 如果有年级ID，延迟获取对应的班级列表（等待年级列表加载完成）
          if (that.info.gradeId) {
            setTimeout(() => {
              that.getClassListByGrade(that.info.gradeId);
            }, 300);
          }
        }
      }
      that.show_type = e;
      that.show_shardow = true;
    },
    close() {
      let that = this;
      that.show_shardow = false;
      that.show_shardow2 = false;
      that.show_delete = false;
      that.show_img_control = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      let that = this;
      that.pageNumber = val;
      that.ajaxload();
    },
    // 搜索功能
    search() {
      let that = this;
      that.pageNumber = 1;
      that.ajaxload();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../userManagement/userManagement.css");


.show_detail {
  height: 344rem;
}

.shardow_title {
  width: 120rem;
}

.img_box {
  width: 220rem;
  height: 46rem;
  background-color: #f2f2f2;
  text-align: center;
  flex-direction: column;
}

.sons_img {
  width: 100%;
  height: 100%;
}

.img62 {
  width: 18rem;
  height: 14rem;
}

.img_banner {
  width: 40rem;
  height: 30rem;
}

.img_level {
  width: 80rem;
  height: 20rem;
}

.ing {
  margin: 0 auto;
  width: 58px;
  height: 24px;
  background: #E5F9F3;
  border-radius: 3px 3px 3px 3px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #00C085;
}

.over {
  margin: 0 auto;
  width: 58px;
  height: 24px;
  background: #F5F5F5;
  border-radius: 3px 3px 3px 3px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #BFBFBF;
}

.show_detail2 {
  padding-top: 26rem !important;
  height: 280rem;
  display: flex;
  flex-direction: column;
  align-content: center;
}

.url_text {
  text-align: center;
  /* white-space: nowrap; */
  margin-top: 16rem;
}

>>>.el-button {
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/view/projectManagement/projectManagement.vue